// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-h1s","placeholdersHeader":"styles_placeholdersHeader__2eY8V","editorStyle":"styles_editorStyle__3yhdE","placeholdersBox":"styles_placeholdersBox__25B4R"};